import './style.scss';
import { ChildrenProps } from '../../common/model';

export const View = (props: ChildrenProps) => {
    return <div className="tabs">{props.children}</div>;
};
